(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const galleries = new Map();
    const update = (gallery) => {
      gallery.style.setProperty('--sgs-gallery-top', Math.min(100, window.innerHeight - gallery.offsetHeight - 24) + 'px');
    };
    const initialize = () => {
      document.querySelectorAll('[data-sgs-gallery-layout] .product__media-wrapper').forEach((gallery) => {
        if (galleries.has(gallery)) return;
        const observer = new ResizeObserver(() => update(gallery));
        observer.observe(gallery);
        galleries.set(gallery, observer);
        update(gallery);
      });
      galleries.forEach((observer, gallery) => {
        if (!gallery.isConnected) { observer.disconnect(); galleries.delete(gallery); }
      });
    };
    initialize();
    document.addEventListener('shopify:section:load', initialize);
    document.addEventListener('shopify:section:unload', initialize);
    window.addEventListener('resize', () => galleries.forEach((observer, gallery) => update(gallery)));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-global-header"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('pointerover', (event) => {
      if (event.pointerType !== 'mouse') return;
      const item = event.target.closest('.sgs-global-header__jewelry-item');
      if (!item) return;
      clearTimeout(item.sgsCloseTimer);
      item.querySelector('details').open = true;
    });
    document.addEventListener('pointerout', (event) => {
      if (event.pointerType !== 'mouse') return;
      const item = event.target.closest('.sgs-global-header__jewelry-item');
      if (!item || item.contains(event.relatedTarget)) return;
      clearTimeout(item.sgsCloseTimer);
      item.sgsCloseTimer = setTimeout(() => {
        if (!item.matches(':hover')) item.querySelector('details').open = false;
      }, 350);
    });
    document.addEventListener('click', (event) => {
      if (!event.target.closest('.sgs-global-header__jewelry-item')) document.querySelectorAll('.sgs-global-header__jewelry-menu[open]').forEach((menu) => { menu.open = false; });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('.sgs-global-header__jewelry-menu[open]').forEach((menu) => { menu.open = false; menu.querySelector('summary').focus(); });
    });
    document.addEventListener('click', (event) => {
      const option = event.target.closest('.sgs-global-header__country-option');
      if (!option) return;
      const form = option.closest('form');
      form.querySelector('[name="country_code"]').value = option.dataset.countryCode;
      form.submit();
    });
    document.addEventListener('input', (event) => {
      const input = event.target;
      if (!input.matches('.sgs-global-header__localization-form input[type="search"]')) return;
      const query = input.value.trim().toLowerCase();
      input.closest('form').querySelectorAll('.sgs-global-header__country-option').forEach((option) => {
        option.hidden = !option.textContent.toLowerCase().includes(query);
      });
    });

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('.sgs-mobile-toggle');
  if (toggle) {
    const menu = document.getElementById(toggle.getAttribute('aria-controls'));
    menu.querySelectorAll('.sgs-mobile-jewelry').forEach((group) => { group.open = false; });
    menu.showModal();
    toggle.setAttribute('aria-expanded', 'true');
    return;
  }
  const menu = event.target.closest('.sgs-mobile-menu');
  if (!menu) return;
  const bounds = menu.getBoundingClientRect();
  const outside = event.target === menu && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom);
  if (outside || event.target.closest('.sgs-mobile-close') || event.target.closest('.sgs-mobile-menu__links a')) menu.close();
});
document.addEventListener('close', (event) => {
  if (!event.target.matches('.sgs-mobile-menu')) return;
  const toggle = document.querySelector('[aria-controls="' + event.target.id + '"]');
  if (toggle) toggle.setAttribute('aria-expanded', 'false');
}, true);
window.matchMedia('(min-width:750px)').addEventListener('change', (event) => {
  if (event.matches) document.querySelectorAll('.sgs-mobile-menu[open]').forEach((menu) => menu.close());
});
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sgs-homepage"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sgs-hero-slider')) {
    customElements.define('sgs-hero-slider', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-hero-track]');
        this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
        this.previousButton = this.querySelector('[data-hero-prev]');
        this.nextButton = this.querySelector('[data-hero-next]');
        this.index = 0;
        this.timer = null;
        this.touchStartX = 0;
        this.touchEndX = 0;
        if (this.slides.length < 2) {
          this.previousButton.hidden = true;
          this.nextButton.hidden = true;
          return;
        }
        this.previousButton.addEventListener('click', () => this.show(this.index - 1));
        this.nextButton.addEventListener('click', () => this.show(this.index + 1));
        this.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') this.show(this.index - 1);
          if (event.key === 'ArrowRight') this.show(this.index + 1);
        });
        this.addEventListener('touchstart', (event) => {
          this.touchStartX = event.changedTouches[0].clientX;
        }, { passive: true });
        this.addEventListener('touchend', (event) => {
          this.touchEndX = event.changedTouches[0].clientX;
          const distance = this.touchStartX - this.touchEndX;
          if (Math.abs(distance) > 50) this.show(this.index + (distance > 0 ? 1 : -1));
        }, { passive: true });
        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());
        this.start();
      }
      show(index) {
        this.index = (index + this.slides.length) % this.slides.length;
        this.track.style.transform = `translateX(-${this.index * 100}%)`;
        this.slides.forEach((slide, slideIndex) => {
          slide.setAttribute('aria-hidden', slideIndex === this.index ? 'false' : 'true');
        });
        this.stop();
        this.start();
      }
      start() {
        if (this.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.stop();
        this.timer = window.setInterval(() => this.show(this.index + 1), Number(this.dataset.delay) || 6000);
      }
      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }
      disconnectedCallback() {
        this.stop();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
